import React from 'react'
import PropTypes from 'prop-types'

import { Testable } from '@cred/react-testable'

import styles from './ClosingCostsModal.module.scss'

const ModalItem = ({ title, children }) => (
  <>
    <p className="mt-16 bodySmall semiBold">{title}</p>
    <p className="neutral500 bodySmall">{children}</p>
  </>
)
ModalItem.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Array)]).isRequired,
}

const ClosingCostsModal = () => (
  <div className={styles.modalContainer}>
    <Testable className={styles.closingCostTooltip} testId="modalDescription">
      <p className="mb-16 bodySmall neutral500">
        Closing costs are the estimated amount you pay to get your loan. These can also be referred
        to as loan costs or upfront costs. Here are some examples of what your closing costs can
        include:
      </p>
    </Testable>
    <ModalItem title="Points/Lender Credits">
      Points are a one time fee you pay (as a percentage of your loan amount) to secure a lower
      interest rate. Credits are a fee your lender pays (as a percentage of your loan amount)
      towards your closing costs in return for taking a higher interest rate.
    </ModalItem>
    <ModalItem title="Lender Fee">
      Fees for application, underwriting, and processing the loan
    </ModalItem>
    <ModalItem title="Third-party Fees">
      Depending on your particular transaction, you may have third party costs associated with
      getting a new loan. For example, if your property is in a flood zone, you may have to pay for
      flood insurance. If you are transferring title, for example to a trust, at closing, you may
      have to pay an attorney fee to draft the deed for the trust. Other examples of third party
      costs can include Recording Fees and Appraisal Fees.{' '}
    </ModalItem>
  </div>
)

export default ClosingCostsModal
